import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { httpInterceptorProviders } from './core/http/interceptors';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { PubPanelPreset } from './app.theme';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { PRIME_DATE_FORMAT } from './modules/shared/locale/date.pipe';
import { ToolbarComponent } from './modules/header/toolbar/toolbar.component';
import { AnalyticsComponent } from './modules/analytics/analytics.component';
import { BillingNotificationComponent } from './modules/billing-notification/billing-notification.component';
import { ReportTimezoneNotificationComponent } from './modules/shared/components/report-timezone-notification/report-timezone-notification.component';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ToastModule,
        ToolbarComponent,
        BillingNotificationComponent,
        AnalyticsComponent,
        ReportTimezoneNotificationComponent
    ],
    providers: [
        httpInterceptorProviders,
        provideHttpClient(
            withFetch(),
            // todo: move to functional interceptors
            withInterceptorsFromDi()
        ),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: PubPanelPreset,
                options: {
                    darkModeSelector: '.pub-panel-dark-mode',
                    cssLayer: false
                }
            },
            translation: {
                dateFormat: PRIME_DATE_FORMAT
            }
        }),
        MessageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
